//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext } from 'react';

//#endregion

//-----------------------------------------------------------------
export function Spacer( {size, width, height, push_right, fill} ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  //#endregion

  //#region [STYLES]

  const _styles = {
    spacer: {
      marginLeft: push_right ? 'auto' : '',
      width  : fill ? '100%' : width  || size ||  '1rem',
      height : fill ? '100%' : height || size ||  '1rem',
    },
  }

  const SPACER = {
    style: _styles.spacer,
  };
    
  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return <div { ...SPACER } />
  }

  //#endregion

  return display();
}
